import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";

import React from "react";
import "./App.css";
import "./print.css";
import locale from "antd/lib/locale/es_ES";
import { ConfigProvider } from "antd";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Entry from "components/Entry";
import CotizacionPrintPage from "components/Print/CotizacionPrintPage";
import InformePrintPage from "components/Print/InformePrintPage";
import CronogramaPrintPage from "components/Print/CronogramaPrintPage";
import { pathPrintCotizacion, pathPrintInforme, pathPrintCronograma } from "Path";
import { isPrintRoute } from "Util/isPrintRoute";
import "dayjs/locale/es";

import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { getChartLabelPlugin } from "chart.js-plugin-labels-dv";
import { Provider } from "react-redux";

import configureStore from "./Redux/config";
import { createDocStore } from "@syncstate/core";
import { Provider as Proveedor } from "@syncstate/react";
import {  QueryClientProvider } from '@tanstack/react-query';
import queryClient from "Client";
// T3/100A06: una pantalla que falla muestra un aviso en lugar de dejar la app en blanco.
import AppErrorBoundary from "components/common/AppErrorBoundary";



const store = configureStore();
sessionStorage.setItem("redirect", window.location.pathname);

const almacen = createDocStore({
  usuarios: {
    cargando: false,
    docs: [],
    necesita_cargar: true,
  },
});

dayjs.locale("es");
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

Chart.register(getChartLabelPlugin(), ChartDataLabels);

// Print-only pages (/print/cotizacion/:id, /print/informe/:id) must NOT go
// through Entry's normal `authed`/login gate — Entry decides Login vs. Home
// BEFORE any router even mounts, so there is no route-matching layer to
// bypass from inside it. They authenticate purely via a `?token=` short-
// lived JWT (see components/Print/PrintGate.js) instead, since they're
// visited by jag-backend's own isolated Puppeteer browser instance, which
// never carries a real user's session/localStorage. See Util/isPrintRoute.js.
//ok
function PrintApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={pathPrintCotizacion} element={<CotizacionPrintPage />} />
        <Route path={pathPrintInforme} element={<InformePrintPage />} />
        <Route path={pathPrintCronograma} element={<CronogramaPrintPage />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  const printRoute = isPrintRoute(window.location.pathname);

  return (
    <QueryClientProvider client={queryClient}>
      <Proveedor store={almacen}>
        <Provider store={store}>
          <ConfigProvider locale={locale}>
            {/* T3/100A06: antes {printRoute ? <PrintApp /> : <Entry />} sin protección */}
            <AppErrorBoundary>
              {printRoute ? <PrintApp /> : <Entry />}
            </AppErrorBoundary>
          </ConfigProvider>
        </Provider>
      </Proveedor>
    </QueryClientProvider>
  );
}

export default App;
